export default __webpack_public_path__ + "static/media/11 00_00_00-01_33_00.10aa9c9f.mp4";